export const clearSearchParams = (searchParams: URLSearchParams) => {
  // Iterate over all keys and delete them
  for (const key of Array.from(searchParams.keys())) {
    searchParams.delete(key);
  }

  // Set the modified URLSearchParams object
  return searchParams;
};
